module.exports = __webpack_public_path__ + "img/upper_frame_middle.18323071.png";